<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<div class="image"><p class="image-right">
<img alt="ink splotch" src="image/bloom.jpg"/>
</p></div>
<h1 class="part_num" id="_idParaDest-2">PART 1</h1>
<h2 class="part_name">HENRY</h2>
<p class="intro">A good man is a good man, whether in this church or out of it.</p>
<p class="intro_attrib">Brigham Young</p><br/><br/>
<h3 class="Chapter-date">Eight Weeks Earlier</h3>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?c226af2e